import React from 'react';
import TimeFilterWrapper from '../TimeFilterWrapper/TimeFilterWrapper';
// import './TopbarFiltersForRm.css';
import AddLeadButton from '../../common/components/AddLeadButton/AddLeadButton';
import AddBpButton from '../../common/components/AddBpButton/AddBpButton';
const TopbarFiltersForRm = ({ itsCM, hideBpBtn, hideAddLeadBtn, user }) => {
  return (
    <>
      <div className="flex flex-row flex-wrap justify-between ml-6 mt-4">
        <TimeFilterWrapper user={user} />
        {!itsCM && (
          <div className="hidden md:flex flex-row flex-wrap ">
            {hideBpBtn ? null : <AddBpButton />}
            {hideAddLeadBtn ? null : <AddLeadButton />}
          </div>
        )}
      </div>
    </>
  );
};

export default TopbarFiltersForRm;
